import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { UserService } from 'src/app/services/user/user.service';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

/**
 * Interceptor adds the user's auth token to any HTTP request
 */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    /**
     * Constructor to initalize services
     */
    constructor(
        private _userService: UserService,
        private _toastrService: ToastrService,
    ) {}

    /**
     * Intercept any HTTP request 
     * @param req
     * @param next 
     * @returns HTTP Response
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Subscribe for errors in the request
        return next.handle(req).pipe(
            catchError((res: HttpErrorResponse) => {
                switch (res.status) {
                    // If we are unauthorized, log out
                    case 401:
                        this._userService.logout();
                        return new Observable<HttpEvent<any>>();

                    // If the backend is not found, log special error 
                    case 0:
                        console.error(`[ERR]: backend is offline`);
                        this._toastrService.error("Database is offline");
                        return new Observable<HttpEvent<any>>();

                    default:
                        // Otherwise, log error and show it to the user
                        console.error(`[ERR]: error in http response`, res.error);
                        this._toastrService.error(res.error.message);
                        return throwError(() => res);
                }
            })
        );
    }

}